import baseUrl from './baseUrl';

const URL_UPDATE_CHAMADO = `${baseUrl}/responder/update`;

const updateChamado = async (id, update) => {
  try {
    const data = await fetch(`${URL_UPDATE_CHAMADO}/${id}`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(update)
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default updateChamado;
